<template>
    <a-row>
        <a-tabs default-active-key="1">
            <a-tab-pane key="1">
              <span slot="tab">
                <a-icon type="highlight"/>
                生成器
              </span>
                <a-card hoverable>
                    <a-alert
                            message="请注意文明用语!"
                            type="warning"
                            closable
                    />
                    <a-divider/>

                    <a-textarea v-model="sourceText" placeholder="请输入要转换的语句" allow-clear @keyup.native="handleToCxh"
                                :auto-size="{ minRows: 5, maxRows: 10 }">
                    </a-textarea>
                    <a-row class="btn-container">
                        <a-button type="primary" icon="arrow-down" @click="handleToCxh">
                            中文 => 抽象话
                        </a-button>
                        <a-button icon="arrow-up" @click="handleToPinyin">
                            抽象话 => 拼音
                        </a-button>
                        <a-button id="copyBtn" type="dashed" icon="copy" @click="handleCopy"
                                  :data-clipboard-text="targetText">
                            复制结果
                        </a-button>
                    </a-row>
                    <a-textarea v-model="targetText" placeholder="生成的抽象话"
                                :auto-size="{ minRows: 5, maxRows: 10 }"></a-textarea>
                </a-card>
            </a-tab-pane>
            <a-tab-pane key="2">
              <span slot="tab">
                <a-icon type="question-circle"/>
                说明
              </span>
                <a-card hoverable>
                    <ul class="desc-list">
                        <li>
                            抽象话是抽象文化的主要表现方式，随着狗粉丝们不断造梗，抽象话也衍生出许多新的内涵，并在网际网路上不断扩散，许多地方都有抽象话的影子。
                        </li>
                        <li>
                            由于抽象话中常包含大量脏话，为了突破言论审查敏感词的限制，常常用一些谐音的emoji来表示。后来则不仅是脏话，各种词汇都用emoji来表示，形成了一种独特的语法，使得人类的文字表现形式退化到了史前的象形文字时期。
                        </li>
                        <li>
                            抽象话的含义与词语原意不同，需要加以区分。亦请不要随意使用抽象语言，以免引起不必要的争端。
                        </li>
                    </ul>
                </a-card>
            </a-tab-pane>
        </a-tabs>

    </a-row>


</template>

<script>
    import Clipboard from 'clipboard';

    export default {
        name: "GifPage",
        components: {},
        mounted() {

        },
        data() {
            return {
                sourceText: '',
                targetText: ''
            }
        },
        methods: {
            handleToCxh() {
                this.targetText = chouxiang(this.sourceText);
            },
            handleToPinyin() {
                this.sourceText = dechouxiang(this.targetText);
            },
            handleCopy() {
                let clipboard = new Clipboard('#copyBtn')
                clipboard.on('success', () => {
                    this.$message.success("拷贝成功!");
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', () => {
                    // 不支持复制
                    console.log('该浏览器不支持自动复制')
                    // 释放内存
                    clipboard.destroy()
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .btn-container {
        padding: 10px;

        .ant-btn {
            margin: 5px 10px;
        }
    }

    .desc-list {
        &>li {
            list-style: circle;
            float: left;
        }
    }
</style>
